import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";
import {withRouter, Redirect, Route, Switch} from 'react-router-dom';
import MarketInsightsHighCharts from "./MarketInsightsHighCharts";
import ChartsSidebar from "./ChartsSidebar";
import './Charts.scss';

const Charts = (props) => {

    const { match } = props;

    return (
            <div className="chartsPage">

                <Helmet>
                    <title>Analytics Center | MarketAxess</title>
                </Helmet>

                <div className="charts__wrapper container" style={{marginTop: '70px', marginBottom: '70px'}}>

                    <ChartsSidebar path={match.path} />

                    <main className="charts__main">
                        <Switch>

                            <Route exact path={`${match.path}/market-insights/:id`} component={MarketInsightsHighCharts} />
                            <Route path={`${match.path}/market-insights`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/market-insights/0`} />
                            )}/>

                            {/* Ensure that landing on / will direct the user to a usable page */}
                            <Route path={`${match.path}`} exact component={() => (
                                <Redirect from={match.path} to={`${match.path}/market-insights/0`} />
                            )}/>

                        </Switch>
                    </main>

                </div>

            </div>
    );
};

Charts.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    match: PropTypes.object.isRequired
};

export default withRouter(Charts);



// WEBPACK FOOTER //
// ./frontend/pages/Charts/Charts.jsx